import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../Services/AuthService";
import { Field, FormError } from "../Components/Form/Field";
import { SubmitButton } from "../Components/Form/SubmitButton";
import { useSubmit } from "../Hooks/useSubmit";
import Footer from "../Components/Footer";
import "../Styles/Forms.css";

/**
 * Begär en återställningslänk.
 *
 * KVITTOT ÄR DETSAMMA OAVSETT UTFALL. Servern svarar likadant för en adress
 * som finns och en som inte gör det (se api/authRoutes.js), och den här
 * sidan måste göra samma sak — annars läcker gränssnittet exakt det API:et
 * var noga med att dölja: vilka adresser som har konton hos oss.
 */
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const { submit, pending, fieldError, formError } = useSubmit(async () => {
    await forgotPassword(email);
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const result = await submit();
    if (result.ok) setSent(true);
  };

  if (sent) {
    return (
      <main className="auth-page">
        <div className="auth-card">
          <h1>Check your inbox</h1>
          <p>
            If there is a Beatspot account for {email}, we have sent a link for
            choosing a new password. It is valid for one hour.
          </p>
          <p>Nothing arrived? Check your spam folder, then try again.</p>
          <Link className="form-link" to="/login">
            Back to sign in
          </Link>
        </div>
        <Footer />
      </main>
    );
  }

  return (
    <main className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit} noValidate>
        <h1>Forgotten password</h1>
        <p>Enter your email address and we will send you a link to reset it.</p>

        <Field label="Email" error={fieldError("email")} required>
          {(props) => (
            <input
              {...props}
              className="form-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              disabled={pending}
            />
          )}
        </Field>

        <FormError message={formError} />

        <SubmitButton pending={pending} pendingLabel="Sending…">
          Send reset link
        </SubmitButton>

        <Link className="form-link" to="/login">
          Back to sign in
        </Link>
      </form>
      <Footer />
    </main>
  );
}
